import styled from 'styled-components/macro'

import Mask from 'assets/mask.png'
import CornerTopLeft from 'assets/corner-top-left.png'
import CornerBottomRight from 'assets/corner-bottom-right.png'
import { mq } from 'styles/mq'
import { Container } from 'components/container'

export const StyledHeader = styled.header`
  position: relative;

  ${mq.medium} {
    padding-bottom: 3rem;

    &::before {
      margin-top: 5rem;
    }
  }
`

export const Content = styled.div`
  ${Container} {
    display: flex;
    flex-direction: column;
    align-items: center;

    ${mq.large} {
      flex-direction: row;
      align-items: end;
      gap: 2.5em;
    }
  }
`

export const Image = styled.img`
  position: relative;
  display: block;
  z-index: 1;
  width: max-content;
  max-width: 100%;
  flex-shrink: 0;
  mix-blend-mode: multiply;

  html:not([dir='rtl']) & {
    transform: rotateY(180deg);
  }

  ${mq.medium} {
    max-width: 80%;
    margin-block-end: -2em;
  }
`

export const TextContent = styled.div`
  text-align: center;

  ${mq.large} {
    text-align: inherit;
  }
`

export const Title = styled.h1`
  margin: 0.6em 0;
  font: 400 clamp(3rem, 8vw, 7rem) / 1.2 var(--font-headings);
  letter-spacing: -0.03em;
  mask: url('${Mask}') center top repeat;

  ${mq.large} {
    font-size: 7rem;
  }
`

export const Intro = styled.div`
  position: relative;
  margin-inline: auto;
  max-width: 26em;
  line-height: 1.6;

  ${mq.medium} {
    margin-block: 3em 2em;
  }

  ${mq.large} {
    font-size: 1.8rem;
    margin-inline: 0;
  }

  p {
    margin: 0;
    mask: url('${Mask}') 0 0 repeat;
  }

  ${mq.medium} {
    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      mix-blend-mode: multiply;
      pointer-events: none;
    }
  }

  &::before {
    top: 0;
    left: 0;
    width: 8.2rem;
    aspect-ratio: 82 / 99;
    margin: -1.8em;
    background: url('${CornerTopLeft}') center center / contain no-repeat;
  }

  &::after {
    bottom: 0;
    right: 0;
    width: 11.5rem;
    aspect-ratio: 115 / 109;
    margin: -2.2em;
    background: url('${CornerBottomRight}') center center / contain no-repeat;
  }
`
